var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearch16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.267 6.128a6.15 6.15 0 0 1-1.178 3.621l3.728 3.74a.957.957 0 0 1 0 1.338.957.957 0 0 1-1.34 0L9.75 11.088a6.125 6.125 0 0 1-3.62 1.179A6.127 6.127 0 0 1 0 6.139a6.127 6.127 0 1 1 12.256-.01h.011Zm-6.139 4.243a4.239 4.239 0 0 0 4.243-4.243 4.239 4.239 0 0 0-4.243-4.242 4.239 4.239 0 0 0-4.242 4.242 4.239 4.239 0 0 0 4.242 4.243Z",
  fill: "#000"
})));
export default SvgSearch16;